import React, { useState } from "react";
import { useNavigate } from "react-router";
import { sendResetPassword } from "@/api/LoginSignup";
import { checkDeletedUserEmail } from "@/api/myProfile";
import { checkEmail, emailNotFound, userDeletedEmail } from "@/setting";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import LoadingText from "@/components/loader/LoadingText";
import LoadedText from "@/components/loader/LoadedText";

const ForgotPassword = ({ printWarning, setShowCustomerCare, email }) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [emailId, setEmailId] = useState(email || "");
  const navigate = useNavigate("");
  const [errorMessage, setErrorMessage] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailSuccess, setEmailSucess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [multipleRequest,setShowMultipleReq] = useState("")

  const handleChange = (e) => {
    const value = e.target.value;
    setEmailId(value);
    printWarning("");
    setEmailError(false);
    setErrorMessage("");
    setShowMultipleReq("")
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      setShowMultipleReq("");

      trackButtonClick({
        eventName: "forgot_password_submit_click",
        eventSource: "Send verification code click",
        eventCategory: "New-Login",
      });

      // Check if email is empty or invalid
      if (!emailId || emailId.trim() === "") {
        setEmailError(true);
        setErrorMessage("Email address is required.");
        return;
      }

      // Validate email format
      if (!emailRegex.test(emailId)) {
        setEmailError(true);
        setErrorMessage("Invalid Email Id");
        return;
      }

      const sendReset = await sendResetPassword(emailId);

      if (sendReset.errorMessage === "INVALID_USER") {
        trackApiCall({
          eventName: "forgot_password_failure",
          eventSource: "Send verification code success",
          eventCategory: "New-Login",
          eventParams: { reason: "invalid_user" },
        });
        printWarning(emailNotFound); // Show user not found warning
      } else if (sendReset.errorMessage === "INVALID_USER_ACCOUNT_STATUS") {
        trackApiCall({
          eventName: "forgot_password_failure",
          eventSource: "Send verification code success",
          eventCategory: "New-Login",
          eventParams: { reason: "invalid_user_account_status" },
        });
        printWarning(userDeletedEmail); // Show user not found warning
      }else if(sendReset.errorMessage === "Too many requests. Please try again later.") {
        setShowMultipleReq("Too many request. Please try after sometime.")
      }
      else {
        setEmailSucess(true);
        setShowCustomerCare(false);

        trackApiCall({
          eventName: "forgot_password_click_success",
          eventSource: "Send verification code success",
          eventCategory: "New-Login",
        });
      }
    } catch (error) {
      console.log(error);
      trackApiCall({
        eventName: "forgot_password_send_error",
        eventSource: "Send verification code failure",
        eventCategory: "New-Registration",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const redirectionToHome = () => {
    trackButtonClick({
      eventName: "forgot_password_close_click",
      eventSource: "Forgot password close click",
      eventCategory: "/register-sign-in",
    });
    navigate("/");
  };

  const checkIsEmailDeleted = async () => {
    if (email.length === 0 || emailError) return;
    try {
      const encodedEmail = encodeURIComponent(email);
      const queryString = `emailId=${encodedEmail}`;
      const deletedUserCheck = await checkDeletedUserEmail(queryString);

      if (deletedUserCheck.data.data) {
        setEmailError(true);
        setErrorMessage(userDeletedEmail);
        printWarning(emailNotFound);

        trackApiCall({
          eventName: "forgot_password_failure",
          eventSource: "Email verification",
          eventCategory: "New-Login",
          eventParams: { reason: "deleted_user" },
        });
      } else {
        setEmailError(false);
        setErrorMessage("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {emailSuccess ? (
        <>
          <p className="fs-15 welcome-para">
            {" "}
            {checkEmail.replace("{email}", emailId)}
          </p>
          <button
            id="forgot-password-close-btn"
            type="submit"
            className="btn btn-log w-100 mt-2"
            onClick={redirectionToHome}
          >
            Close
          </button>
        </>
      ) : (
        <>
          <div className="input-group mb-2 mr-sm-2">
            <input
              id="forgot-password-email-input"
              type="text"
              className={`form-control form-field mb-0 ${
                emailError ? "input-error" : ""
              }`}
              placeholder="Email ID"
              value={emailId}
              autoComplete="email"
              onChange={handleChange}
              // onBlur={checkIsEmailDeleted}
            />
            <div className="input-group-prepend">
              <div className="input-group-text">
                {/* <i className="flaticon-user"></i> */}
              </div>
            </div>
          </div>
          {emailError && <div className="error-css">{errorMessage}</div>}
          <button
            id="forgot-password-send-btn"
            type="submit"
            // disabled={emailError || email.length === 0}
            className="btn btn-log w-100 hubzu-btn-thm mt-2"
            onClick={handleSubmit}
          >
            {isLoading ? (
              <LoadingText text="Sending verification code" />
            ) : (
              <LoadedText text="Send" />
            )}
          </button>
          {
            multipleRequest?.length>0 && <p className="error-css">{multipleRequest}</p>
          }
        </>
      )}
    </>
  );
};

export default ForgotPassword;
